// extracted by mini-css-extract-plugin
export default {"toggle":"Project_toggle__-lcuK","wrapper":"Project_wrapper__RG-1E","editTitle":"Project_editTitle__skYJw"};